export enum MessageType{
    Text = 'text',
    Zumbido = 'zumbido',
    Image = 'image'
}